import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import config from "../../config/config";
import CurrencySymbols from "../../common/CurrencySymbol";
import { AppContext } from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const CommonPreviousInvoiceComponent = ({
  moduleType,
  moduleId,
  invoiceTotal,
}) => {
  const token = localStorage.getItem("Token") || "";
  const { FractionDigits, CurrencySymbol, dateFormate } =
    useContext(AppContext);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handlePaymentClick = (payment) => {
    let baseUrl = "";
    if (payment.isReceivePayment === 1) {
      baseUrl = "receive-payment";
    } else if (payment.isBillPayment === 1) {
      baseUrl = "receiving-paybills";
    }
    navigate(`/${baseUrl}/${payment.id}`);
  };

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const response = await axios.get(
          `${config.accountingBaseUrl}/chartofaccounts/getpreviousinvoicerecord?id=${moduleId}&type=${moduleType}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        );

        if (response.data.ResponseCode === "SUCCESS") {
          setPayments(response.data.ResponseData);
        } else {
          setPayments([]);
        }
        setLoading(false);
      } catch (error) {
        console.error(
          "Error fetching payments:",
          error?.response?.data || error.message
        );
        setPayments([]);
        setLoading(false);
      }
    };

    if (moduleId) {
      fetchPayments();
    }
  }, [moduleType, moduleId]);

  const calculateBalanceDue = () => {
    const totalPaid = payments.reduce(
      (sum, payment) => sum + Number(payment.value),
      0
    );
    return Number(invoiceTotal || 0) - totalPaid;
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  return (
    <>
      {payments.length > 0 && (
        <div className="card shadow-sm mx-auto" style={{ maxWidth: "" }}>
          <div className="card-header">
            <strong>Payment Details</strong>
          </div>
          <div className="card-body">
            <div className="container p-0">
              <div className="row mb-2">
                <div className="col-2">
                  <span className="fw-bold">Date</span>
                </div>
                <div className="col-4 text-end">
                  <span className="fw-bold">Num</span>
                </div>
                <div className="col-6 text-end">
                  <span className="fw-bold">Amount</span>
                </div>
              </div>

              <hr className="my-2" />

              {payments.map((payment, index) => (
                <div key={index} className="row mb-2 text-muted">
                  <div className="col-4">
                    <span
                      className="cursor-pointer text-primary"
                      onClick={() => handlePaymentClick(payment)}
                      style={{ cursor: "pointer" }}
                    >
                      {/* {payment.label} */}
                      {moment(payment.label).format(
                        `${dateFormate.toUpperCase()}`
                      )}
                    </span>
                  </div>
                  <div className="col-4">{payment.RefNo}</div>
                  <div className="col-4 text-end">
                    {CurrencySymbols(
                      Number(payment.value),
                      CurrencySymbol,
                      FractionDigits
                    )}
                  </div>
                </div>
              ))}
              {(moduleType == "Memo" ||
                moduleType == "Invoice" ||
                moduleType == "Bill" ||
                moduleType == "Vendor Credit") && (
                <>
                  <hr className="my-2" />
                  <li className="d-flex justify-content-between align-items-center mb-2">
                    <span className="fw-bold">{`${moduleType} Total`}</span>
                    <span className="fw-bold">
                      {CurrencySymbols(
                        Number(invoiceTotal || 0),
                        CurrencySymbol,
                        FractionDigits
                      )}
                    </span>
                  </li>
                  <li className="d-flex justify-content-between align-items-center">
                    <span className="fw-bold">Balance due</span>
                    <span className="fw-bold">
                      {CurrencySymbols(
                        Number(calculateBalanceDue()),
                        CurrencySymbol,
                        FractionDigits
                      )}
                    </span>
                  </li>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
  //   return (
  //     <div className="card shadow-sm mx-auto" style={{ maxWidth: "400px" }}>
  //       <div className="card-header"><strong>Payment Details</strong></div>
  //       <div className="card-body">
  //         {moduleType === "Bill" || moduleType === "Journal" ? (
  //           <div className="container p-0">
  //             <div className="row mb-2">
  //               <div className="col-2">
  //                 <span className="fw-normal">Date</span>
  //               </div>
  //               <div className="col-6 text-end">
  //                 <span className="fw-normal">Amount applied</span>
  //               </div>
  //               <div className="col-4 text-end">
  //                 <span className="fw-normal">Num.</span>
  //               </div>
  //             </div>

  //             <hr className="my-2" />

  //             {payments.map((payment, index) => (
  //               <div key={index} className="row mb-2 text-muted">
  //                 <div className="col-4">
  //                   <span
  //                     className="cursor-pointer text-primary"
  //                     onClick={() => handlePaymentClick(payment)}
  //                     style={{ cursor: "pointer" }}
  //                   >
  //                     {payment.label}
  //                   </span>
  //                 </div>
  //                 <div className="col-4">
  //                   {CurrencySymbols(
  //                     Number(payment.value),
  //                     CurrencySymbol,
  //                     FractionDigits
  //                   )}
  //                 </div>
  //                 <div className="col-4 text-end">{payment.RefNo}</div>
  //               </div>
  //             ))}
  //           </div>
  //         ) : moduleType === "Memo" || moduleType === "Expense" ? (
  //           <ul className="list-unstyled mb-0">
  //             <li className="d-flex justify-content-between align-items-center mb-2">
  //               <span className="fw-normal">Date</span>
  //               <span className="fw-normal">Amount applied</span>
  //             </li>

  //             <hr className="my-2" />

  //             {payments.map((payment, index) => (
  //               <li
  //                 key={index}
  //                 className="d-flex justify-content-between align-items-center mb-2 text-muted"
  //               >
  //                 <span
  //                   className="cursor-pointer text-primary"
  //                   onClick={() => handlePaymentClick(payment)}
  //                   style={{ cursor: "pointer" }}
  //                 >
  //                   {payment.label}
  //                 </span>
  //                 <span>
  //                   {CurrencySymbols(
  //                     Number(payment.value),
  //                     CurrencySymbol,
  //                     FractionDigits
  //                   )}
  //                 </span>
  //               </li>
  //             ))}
  //           </ul>
  //         ) : moduleType === "Deposit" ? (
  //           <ul className="list-unstyled mb-0">
  //             <li className="d-flex justify-content-between align-items-center mb-2">
  //               <span className="fw-normal">Deposit Uses</span>
  //               {/* <span className="fw-normal">
  //                                     {CurrencySymbols(
  //                                         Number(invoiceTotal || 0),
  //                                         CurrencySymbol,
  //                                         FractionDigits
  //                                     )}
  //                                 </span> */}
  //             </li>

  //             <hr className="my-2" />

  //             {payments.map((payment, index) => (
  //               <li
  //                 key={index}
  //                 className="d-flex justify-content-between align-items-center mb-2 text-muted"
  //               >
  //                 <span
  //                   className="cursor-pointer text-primary"
  //                   onClick={() => handlePaymentClick(payment)}
  //                   style={{ cursor: "pointer" }}
  //                 >
  //                   {payment.label}
  //                 </span>
  //                 <span>
  //                   {CurrencySymbols(
  //                     Number(payment.value),
  //                     CurrencySymbol,
  //                     FractionDigits
  //                   )}
  //                 </span>
  //               </li>
  //             ))}

  //             {/* <hr className="my-2" />

  //                             <li className="d-flex justify-content-between align-items-center">
  //                                 <span className="fw-bold">Balance due</span>
  //                                 <span className="fw-bold">
  //                                     {CurrencySymbols(
  //                                         Number(calculateBalanceDue()),
  //                                         CurrencySymbol,
  //                                         FractionDigits
  //                                     )}
  //                                 </span>
  //                             </li> */}
  //           </ul>
  //         ) : (
  //           <ul className="list-unstyled mb-0">
  //             <li className="d-flex justify-content-between align-items-center mb-2">
  //               <span className="fw-normal">Invoice total</span>
  //               <span className="fw-normal">
  //                 {CurrencySymbols(
  //                   Number(invoiceTotal || 0),
  //                   CurrencySymbol,
  //                   FractionDigits
  //                 )}
  //               </span>
  //             </li>

  //             <hr className="my-2" />

  //             {payments.map((payment, index) => (
  //               <li
  //                 key={index}
  //                 className="d-flex justify-content-between align-items-center mb-2 text-muted"
  //               >
  //                 <span
  //                   className="cursor-pointer text-primary"
  //                   onClick={() => handlePaymentClick(payment)}
  //                   style={{ cursor: "pointer" }}
  //                 >
  //                   {payment.label}
  //                 </span>
  //                 <span
  //                   className="cursor-pointer text-primary"
  //                   onClick={() => handlePaymentClick(payment)}
  //                   style={{ cursor: "pointer" }}
  //                 >
  //                   #{payment.RefNo}
  //                 </span>
  //                 <span>
  //                   -
  //                   {CurrencySymbols(
  //                     Number(payment.value),
  //                     CurrencySymbol,
  //                     FractionDigits
  //                   )}
  //                 </span>
  //               </li>
  //             ))}

  //             <hr className="my-2" />

  //             <li className="d-flex justify-content-between align-items-center">
  //               <span className="fw-bold">Balance due</span>
  //               <span className="fw-bold">
  //                 {CurrencySymbols(
  //                   Number(calculateBalanceDue()),
  //                   CurrencySymbol,
  //                   FractionDigits
  //                 )}
  //               </span>
  //             </li>
  //           </ul>
  //         )}
  //       </div>
  //     </div>
  //   );
};

export default CommonPreviousInvoiceComponent;
